export const getOperationTypeFilter = state => state.operationType.filter
